import React, { useState } from "react";
import "../styles/faq.scss";

const faqData = [
  {
    question: "Koji su materijali koji se koriste za medicinske uniforme?",
    answer:
      "Medicinske uniforme izrađujemo od visokokvalitetnih pamučnih i sintetičkih mešavina koje pružaju udobnost, otpornost na habanje i lako održavanje."
  },
  {
    question: "Da li su medicinske uniforme dostupne u različitim bojama?",
    answer:
      "Da, nudimo medicinske uniforme u raznim bojama, uključujući standardne bele, plave i zelene, kao i personalizovane boje po zahtevu."
  },
  {
    question: "Da li medicinske uniforme imaju antibakterijska svojstva?",
    answer:
      "Mnoge naše medicinske uniforme dolaze sa antibakterijskom zaštitom koja pruža dodatnu higijenu tokom celodnevnog nošenja."
  },
  {
    question: "Kako održavati medicinske uniforme?",
    answer:
      "Naše medicinske uniforme se lako održavaju i mogu se prati u mašini na visokim temperaturama kako bi se osigurala maksimalna čistoća."
  },
  {
    question: "Da li su kuvarske uniforme otporne na fleke?",
    answer:
      "Da, većina naših kuvarskih uniformi izrađena je od tkanina koje su otporne na fleke i lako se peru, pružajući čistoću tokom rada."
  },
  {
    question: "Koji dodaci dolaze sa kuvarskim uniformama?",
    answer:
      "Kuvarske uniforme mogu uključivati kecelje, kapice, prsluke i druge dodatke za potpunu profesionalnu prezentaciju."
  },
  {
    question: "Da li nudite personalizaciju kuvarskih uniformi?",
    answer:
      "Da, možete personalizovati kuvarske uniforme sa imenom, logotipom ili drugim vezovima kako bi odgovarale vašem timu ili restoranu."
  },
  {
    question: "Da li radne uniforme imaju reflektivne trake?",
    answer:
      "Da, mnoge naše radne uniforme uključuju reflektivne elemente za povećanu bezbednost tokom rada u lošim uslovima osvetljenja."
  },
  {
    question: "Koji su standardi bezbednosti za radne uniforme?",
    answer:
      "Naše radne uniforme su izrađene u skladu sa najvišim bezbednosnim standardima i pružaju dodatnu zaštitu od mehaničkih povreda, vrućine i drugih rizika."
  },
  {
    question: "Da li radne uniforme pružaju zaštitu od hemikalija?",
    answer:
      "Imamo specijalizovane radne uniforme koje pružaju zaštitu od određenih hemikalija, a prilagođene su zahtevima industrije."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h2 style={{ textAlign: "center" }} className="title">
        Najčešća Pitanja
      </h2>
      <div className="faq-list">
        {faqData.map((faq, index) =>
          <div
            key={index}
            className={`faq-item ${openIndex === index ? "open" : ""}`}
          >
            <div className="faq-question" onClick={() => handleToggle(index)}>
              {faq.question}
              <span
                className={`faq-toggle-icon ${openIndex === index
                  ? "rotated"
                  : ""}`}
              >
                {openIndex === index ? "▲" : "▼"}
              </span>
            </div>
            <div
              className="faq-answer"
              style={{ maxHeight: openIndex === index ? "500px" : "0px" }}
            >
              <p>
                {faq.answer}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQ;
